import {Types} from './actions';
import initialState from './initialState';
import ReducerBuilder from 'classes/ReducerBuilder';

export default ReducerBuilder.make(initialState)
  .forType(Types.REQUEST_PRIZES).reduce((state, action) => {
    state.currentPrizeType = null;
  })
  .forType(Types.REQUESTED_PRIZES)
  .reduce((state, action) => {
    state.fetchingPrizes = true;
    state.currentPrizeType = action.prizeType;
  })
  .forType(Types.RECEIVED_PRIZES)
  .reduce((state, action) => {
    state.fetchingPrizes = false;
  })
  .forType(Types.SET_PRIZE_DATE_RANGE_FILTER_TYPE)
  .reduce((state, action) => {
    state.dateRangeFilterType = action.filterType;
  })
  .build();



// WEBPACK FOOTER //
// ./public/pages/ListPrizes/reducer.js